/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-26 11:39:10
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import MainMenu from 'src/components/containers/main-menu';

import type { ComposedProps, State } from './index.type';

class RecommendationDefaultDesignSettings extends Component<ComposedProps, State> {
  state = {
  };

  componentDidMount() {
  }

  render() {
    return (
      <div className="BC-Page BC-Page__RecommendationDefaultDesignSettings">
        <MainMenu menuId="menu-recommendation-default-design-settings" />
        <p>Recommendation Default Design Settings</p>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  
});

const mapStateToProps = (state, props) => {
  return {
    
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(RecommendationDefaultDesignSettings));
